import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import BrandingView from "./branding.view";

const useBrandingRoutes = () => (
  <Route path={pages.branding.path} element={<BrandingView />}>
    <Route index element={<BrandingView />} />
  </Route>
);

export default useBrandingRoutes;
